export enum TelegramBotConnectionStatus {
  PENDING = 'PENDING',
  CONNECTED = 'CONNECTED',
}

export interface TelegramBotConnection {
  /** PK — this+that user id (Clerk). */
  userId: string;
  /**
   * SK — Telegram bot id (numeric prefix of the bot token). Required in the key:
   * DynamoDB tables are shared across stages and a private chat.id equals the
   * Telegram user id for every bot, so dev/prod links would collide without it.
   */
  botId: string;
  status: TelegramBotConnectionStatus;
  /** Telegram private chat id; set on connect. GSI hash of TelegramBotConnectionsByChatIndex. */
  chatId?: string;
  /** Single-use deep-link nonce; cleared on connect. */
  linkNonce?: string;
  linkRequestedAt?: number;
  /** DynamoDB TTL (epoch seconds); set on PENDING, removed on connect. */
  ttl?: number;
  createdAt: number;
  updatedAt: number;
}

/** API-facing connection state for the Telegram Assistant card (adds the "no row" case). */
export enum TelegramAssistantConnectionState {
  NOT_CONNECTED = 'NOT_CONNECTED',
  PENDING = 'PENDING',
  CONNECTED = 'CONNECTED',
}
